import { all, call, getContext, put, select, takeEvery } from 'redux-saga/effects';
import type { Action } from '../utils';
import type { ILogEntry } from '../../api/domain/logging/log-entry';
import type { LoggingApiService } from '../../api/services/logging/logging-api-service';
import type { Tenant } from '../../enum/tenant';
import { getTenant } from '../application/application-selectors';
import { getUserId } from '../portal-account-api/portal-account-api-selectors';
import { writeLogEntry, writeLogEntryFailure, writeLogEntrySuccess } from './logging-api-actions';

function* handleWriteLog(action: Action<ILogEntry>) {
    const api: LoggingApiService = yield getContext('loggingApiService');
    try {
        const tenant: Tenant = yield select(getTenant);
        const userId: string = yield select(getUserId);
        const logEntry: ILogEntry = {
            ...action.payload,
            moduleVersion: '1.0',
            loggerName: `esprit-portal-${tenant}-${userId || 'anonymous'}`,
        };
        yield call([api, api.writeLog], logEntry);
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.error(action.payload);
        }
        yield put(writeLogEntrySuccess());
    } catch (e: unknown) {
        yield put(writeLogEntryFailure());
    }
}

export function* loggingApiSaga() {
    yield all([takeEvery(writeLogEntry, handleWriteLog)]);
}
